export default function dashesTransform(input) {
  return input.replace(/|/g, "̶");
}
